var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 100,
    viewBox: "0 0 150 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5279_18347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.5948 40.0754C96.5945 39.2704 96.4223 38.5591 96.0742 37.9486C95.7322 37.3482 95.22 36.8451 94.533 36.4472C88.8622 33.1774 83.1858 29.9176 77.5168 26.6444C75.9885 25.7621 74.5067 25.7942 72.9897 26.6892C70.7325 28.0204 59.4317 34.4949 56.0642 36.4454C54.6773 37.2482 54.0025 38.4769 54.0022 40.0739C54 46.6497 54.0022 53.2254 54 59.8014C54 60.5887 54.1652 61.2862 54.498 61.8876C54.8402 62.5061 55.3595 63.0231 56.0623 63.4299C59.43 65.3804 70.7323 71.8544 72.989 73.1859C74.5067 74.0814 75.9885 74.1134 77.5173 73.2307C83.1865 69.9574 88.8632 66.6977 94.5348 63.4279C95.2377 63.0212 95.757 62.5039 96.0992 61.8859C96.4315 61.2846 96.597 60.5871 96.597 59.7996C96.597 59.7996 96.597 46.6514 96.5948 40.0754Z",
    fill: "#A179DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3637 49.8736L54.498 61.8876C54.8402 62.5061 55.3595 63.0231 56.0624 63.4299C59.43 65.3804 70.7324 71.8544 72.989 73.1859C74.5067 74.0814 75.9885 74.1134 77.5174 73.2307C83.1865 69.9574 88.8632 66.6977 94.5349 63.4279C95.2377 63.0212 95.757 62.5039 96.0992 61.8859L75.3637 49.8736Z",
    fill: "#280068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5949 40.0754C96.5946 39.2704 96.4224 38.5591 96.0743 37.9486L75.3638 49.8736L96.0993 61.8859C96.4316 61.2846 96.5968 60.5871 96.5971 59.7996C96.5971 59.7996 96.5971 46.6514 96.5949 40.0754Z",
    fill: "#390091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6487 45.3823V47.6279H89.8943V45.3823H91.0171V47.6279H93.2627V48.7508H91.0171V50.9964H93.2627V52.1192H91.0171V54.3648H89.8943V52.1192H87.6487V54.3648H86.5259V52.1192H84.2803V50.9964H86.5259V48.7508H84.2803V47.6279H86.5259V45.3823H87.6487ZM89.8943 48.7508H87.6487V50.9964H89.8943V48.7508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4096 34.1043C81.2669 34.1043 86.3808 37.2854 89.1199 42.0137L89.0932 41.9681L82.2017 45.9362C80.844 43.6373 78.3548 42.0858 75.4995 42.0539L75.4096 42.0534C71.0553 42.0534 67.5253 45.5833 67.5253 49.9376C67.5253 51.3615 67.9049 52.6963 68.5651 53.8491C69.9241 56.2217 72.4789 57.8219 75.4096 57.8219C78.3584 57.8219 80.9277 56.2013 82.2799 53.8034L82.247 53.861L89.1281 57.8473C86.419 62.5356 81.3752 65.7068 75.586 65.77L75.4096 65.771C69.5338 65.771 64.4054 62.5703 61.6732 57.817C60.3393 55.4966 59.5762 52.8063 59.5762 49.9376C59.5762 41.1932 66.6649 34.1043 75.4096 34.1043Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5279_18347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.6667,
    height: 48,
    fill: "white",
    transform: "translate(54 26)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsharp);
export default __webpack_public_path__ + "static/media/csharp.ab05d2a66a160cca9d8d13681f307b38.svg";
export { ForwardRef as ReactComponent };